export default {
  unavailableTitle: 'Product unavailable',
  unavailableText: "We couldn't load this product. It may have been removed or the catalog API is unreachable.",
  backToCatalog: 'Back to catalog',
  catalog: 'Catalog',
  baseGame: 'Base game',
  inStock: 'In stock',
  outOfStock: 'Out of stock',
  inCart: 'In cart',
  addToCart: 'Add to cart',
  addToWishlist: 'Add to wishlist',
  logInToProceed: 'Log in to proceed',
  aboutTheGame: 'About the game',
  noDescription: 'No description available.',
  showMore: 'Show more',
  showLess: 'Show less',
  details: 'Details',
  releaseDate: 'Release Date',
  metacritic: 'Metacritic',
  developer: 'Developer',
  publisher: 'Publisher',
  platform: 'Platform',
  ageRating: 'Age rating',
  region: 'Region',
  regionalRestrictions: 'Regional Restrictions',
  regionalLimitations: 'Regional Limitations: Activates in {region} only.',
  regionLine: 'Region: {regions}.',
  activationDetails: 'Activation Details',
  systemRequirements: 'System requirements',
  visuals: 'Visuals',
  similarGames: 'Similar games',
  noImage: 'No image',
  steamStep1: 'Open Steam client',
  steamStep2: 'Click "Add a Game"',
  steamStep3: 'Select "Activate a Product on Steam"',
  steamStep4: 'Follow instructions to enter code',
  epicStep1: 'Open the Epic Games Launcher',
  epicStep2: 'Sign in to your account',
  epicStep3: 'Go to your Library and redeem code',
  epicStep4: 'Download and play',
  eaStep1: 'Open the EA app / Origin',
  eaStep2: 'Open the menu and choose "Redeem Code"',
  eaStep3: 'Enter your PlayStock key',
  eaStep4: 'Download and play',
  genericStep1: 'Open the official client / launcher',
  genericStep2: 'Find "Activate a product" or "Redeem code"',
  genericStep3: 'Enter your PlayStock key',
  genericStep4: 'Download and play',
};
